import {Stack, Typography, MenuItem} from '@mui/material';
import {Link} from 'react-router-dom';
import {useDarkMode} from '../darkMode/hook/useDarkMode';
import {useNotificationList} from './hooks/useNotificationList';

const NotificationBell = () => {
  const {loading, pendingCount} = useNotificationList();
  const {mode} = useDarkMode();

  return (
    <MenuItem
      role="presentation"
      sx={{
        minWidth: '100px',
        justifyContent: 'center',
        alignItems: 'center',
        padding: '10px',
      }}
      justifyContent="center">
      <Stack
        alignItems="center"
        justifyContent="center"
        direction="column"
        sx={{
          position: 'relative',
        }}>
        {!loading && pendingCount > 0 && (
          <Typography
            component="span"
            sx={{
              position: 'absolute',
              top: -9,
              right: 22,
              width: 22,
              height: 22,
              borderRadius: 22,
              backgroundColor: '#C72B5C',
              fontSize: 14,
              fontWeight: 'bold',
              textAlign: 'center',
            }}>
            {pendingCount}
          </Typography>
        )}
        <img src="/assets/icon/bell.png" style={{width: 27, height: 34}} />
        <Typography
          variant={'subtitle5'}
          className={'menu_item_label'}
          style={{color: mode.settings.textColor}}>
          Notifications
        </Typography>
        <Link
          to={'/notifications'}
          style={{
            position: 'absolute',
            top: 0,
            left: 0,
            display: 'block',
            width: '100%',
            height: '100%',
          }}
        />
      </Stack>
    </MenuItem>
  );
};

export default NotificationBell;
